export default __webpack_public_path__ + "static/media/inventory_sm_icon.75d7e169.svg";